import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client
import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";

import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Savedneighbor
const GQLAddQuestion = gql`
  mutation createcityquestion(
    $question: String
    $userId: String
    $cityName: String
    $postedDate: String
    $updatedDate: String
    $lastUpdated: String
  ) {
    createcityquestion(
      question: $question
      userId: $userId
      cityName: $cityName
      postedDate: $postedDate
      updatedDate: $updatedDate
      lastUpdated: $lastUpdated
    ) {
      success
      message
    }
  }
`;

//Update Savedneighbor
const GQLUpdateQuestion = gql`
  mutation updateQuestionandAnswer($id: String!, $neighborhoodId: String) {
    Updatequestionandanswers(id: $id, neighborhoodId: $neighborhoodId) {
      success
      message
    }
  }
`;

//Delete Savedneighbor
const GQLDeleteQuestionandAnswer = gql`
  mutation deleteQuestionandAnswer($id: String!) {
    deletequestionandanswers(id: $id) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getquestions = gql`
  query getcityquestions(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getcityquestions(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      userIds
      cityName
      question
      postedDate
      lastUpdated
      userId {
        id
        type
        firstName
        lastName
        email
        aboutMe
        numberNeighborhoodsReviewed
        questionsAnswered
        realEstateFirm
        license
        phone
        aboutMe
        isagent
        ishomebuyer
        ishomeseller
        isneighbor
        istopagent
        userimage
        displayname
      }
      replies {
        id
        message
        helpContent
        helpfulCount
        helpStatus
        postedDate
        helpedUserId
        firstName
        lastName
        userimage
        type
        realEstateFirm
        displayname
      }
    }
  }
`;

const QUERY_getcitydata = gql`
  query getcitydata(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getcitydata(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      geotype
      id
      name
      areatype
      label
      level
      neighborhoodtype
      census_id
      census_name
      place_id
      place_name
      postalcity_id
      postalcity_name
      county_id
      county_name
      state_id
      state_name
      latitude
      longitude
      geometrytype
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      geometry_cords
      medianprice
      amenities
      centroid
      keyword
      npiAreaRanking
      npiCityRanking
      reviewOneLiner
      reviewSummary
      appreciation
      nhfullname
      neighborhoodImages {
        imageurl
        thumbnailurl
      }
      homes {
        id
        lat
        lang
        address
        price
      }
      walkscorestatus
      is_display_dev
      is_display_prod
      cityMedianPrice
      cityMedianPriceLastMonth
      cityMonthlyMedianPrice
      cityfullname
    }
  }
`;

const QUERY_getsimilarcities = gql`
  query getSimilarCityList(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getSimilarCityList(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      place_id
      place_name
      postalcity_id
      postalcity_name
      county_id
      county_name
      state_id
      state_name
      npi
      personal
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      cityimages {
        imageurl
      }
      walkscorestatus
      npiscore
      valuescore
      cityfullname
      reviewOneLiner
    }
  }
`;

// const QUERY_getquestions = gql`
// query getquestions($start:Int,$limit:Int,$orderBy:String,$order:String,$fields:String,$auth_userId: String){
//     getquestions(start:$start,limit:$limit,orderBy:$orderBy,order:$order,fields:$fields,auth_userId:$auth_userId){
//         id
//         userId{
//           id
//         }
//         neighborhoodId
//         question
//         postedDate
//         lastUpdated
//         replies{
//           id
//           message
//           postedDate
//           helpContent
//           helpfulCount
//           helpStatus
//           helpedUserId
//           userId{
//             id
//             type
//             firstName
//             lastName
//             email
//             aboutMe
//             numberNeighborhoodsReviewed
//             like
//             questionsAnswered
//             point
//             realEstateFirm
//             license
//             phone
//             aboutMe
//             isagent
//             ishomebuyer
//             ishomeseller
//             isneighbor
//             istopagent
//             userimage
//           }
//         }
//     }
// }
// `;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addquestion(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddQuestion,
        variables: {
          userId: adddata.userId,
          cityName: adddata.cityName,
          question: adddata.question,
          postedDate: adddata.postedDate,
          updatedDate: adddata.updatedDate,
          lastUpdated: adddata.lastUpdated,
        },
        options: {
          fetchPolicy: "no-cache",
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updatequestionandanswers(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateQuestion,
        variables: {
          id: updatedata.id,
          neighborhoodId: updatedata.neighborhoodId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deletequestionandanswers(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteQuestionandAnswer,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllquestions(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getquestions,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          auth_userId: getdata.auth_userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getcitydata(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getcitydata,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getsimilarcities(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getsimilarcities,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export {
  addquestion,
  updatequestionandanswers,
  deletequestionandanswers,
  getAllquestions,
  getcitydata,
  getsimilarcities,
};
